define('tdautosuggest', ['jquery'], function ($) {

    var tdautosuggest = {
        suggest: function suggest() {
            $('#search_autocomplete').on('mouseenter', '.searchwords li a', function () {
                var index = $(this).data('index');
                $('#search_autocomplete .products-box .query-result').hide();
                if ($('#search_autocomplete .products-box .query-result-' + index).length) {
                    $('#search_autocomplete .products-box .query-result-' + index).show();

                    return;
                }

                $('#autosuggest-please-wait').show();
                var suggestUrl = $('#search_autocomplete').data('suggest-url');
                suggestUrl = suggestUrl + '&q=' + $(this).data('query');
                new Ajax.Request(suggestUrl, {
                    parameters: {},
                    method: 'get',

                    onSuccess: function onSuccess(transport) {
                        $('#autosuggest-please-wait').delay(3000).hide();
                        var html = $($.parseHTML(transport.responseText));
                        var newResult = html.find('.products-box .query-result');
                        newResult.addClass('query-result-' + index);
                        $('#search_autocomplete .products-box').append(newResult);
                    }
                });
            });
        },
        init: function init() {
            this.suggest();
        }
    };

    return tdautosuggest;
});

